// 공지사항 vuex
const noticeStore = {
  namespaced: true,

  state: {
    notice: {},
    isWrite: false,
    id: ''
  },

  getters: {
    getNotice: state => state.notice,
    getIsWrite: state => state.isWrite,
    getNoticeID: state => state.id
  },

  mutations: {
    mutationNotice: (state, payload) => {
      state.notice = payload
    },

    mutationIsWrite: (state, payload) => {
      state.isWrite = payload
    },
    mutationNoticeID: (state, payload) => {
      state.id = payload
    }
  }
}

export default noticeStore
